export default {
  GROUPS_FETCHED(state, groups) {
    state.groups = groups
    state.loading = false
  },
  SET_LOADING(state, loading) {
    state.loading = loading
  }
}
